import styled from 'styled-components/macro';
import {TABLET_BREAKPOINT} from "../../app/constants";

export const StyledResults = styled.div`
  height: calc(100vh - 363px);
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    height: calc(100% - 81px);
  }
`;
